<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="header text-center">
            <h4 class="title">Create New Client</h4>
          </div>
          <create-client-form />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import CreateClientForm from './Clients/CreateClientForm.vue'

  export default {
    components: {
      CreateClientForm,
    }
  }

</script>
<style>

</style>
